import { Button, Checkbox, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { lensLogo, tekWhite } from "../assets"
import { doLogin } from "../services/user.service"
import { useAppDispatch } from "../store/hooks"
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux"
import { appConfigSelector } from "../store/selectors/app.selector"
import { CONFIGNAME } from "../types/global.enum"
import { getVoiceApi, getCognitoConfig } from "../services/config.service"

export const Login = () => {
    const dispatch = useAppDispatch();
    const appConfig = useSelector(appConfigSelector);

    const { t } = useTranslation();
    
    const [form, setForm] = useState<any>({
        username: '',
        password: '',
        remember:false,
    })

    const loginOnEnter = async (e:any)=> {
        if(e.keyCode === 13) {
            await login();
        }
    }

    const sso = ()=> {
        document.location.href=`${getVoiceApi()?.replace('/api/voice/v1','')}/?redirectUrl=${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}`:``}/callback`;
    }

    const cognitoLogin = async ()=> {
        const config = await getCognitoConfig();
        const redirectUri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ``}/callback`;

        // Build Cognito OAuth URL
        const cognitoUrl = `${config.domain}/oauth2/authorize?` +
            `client_id=${config.clientId}&` +
            `response_type=${config.responseType}&` +
            `scope=${encodeURIComponent(config.scope)}&` +
            `redirect_uri=${encodeURIComponent(redirectUri)}`;

        document.location.href = cognitoUrl;
    }

    const login = async () => {
        const status = await doLogin(form.username, form.password, dispatch);

        if (status) {
            localStorage.setItem('APP_USERNAME', form.remember ? form.username:'');
            const redirectUrl = localStorage.getItem('REDIRECT_URL');
            if (redirectUrl) {
                localStorage.removeItem('REDIRECT_URL');
                document.location.href = redirectUrl;
            } else {
                document.location.href = "/";
            }
        }
    }

    useEffect(()=> {
        const username = localStorage.getItem('APP_USERNAME');
        if(username) {
            setForm({
                username,
                remember:true,
            })
        }
    },[]);


    return (
        <div className="login-container">
            <div className="login-area">
                <div className="login-left">
                    <img src={tekWhite} alt="" />
                    <div className="version">v5.1</div>
                </div>
                <div className="login-right">
                    <div className="center-logo">
                        <img src={lensLogo} alt="" />

                        <div className="db mt-24">
                            <Button
                                variant={'contained'}
                                color={"primary"}
                                className='btn-primary'
                                onClick={cognitoLogin}
                                style={{ width: '245px' }}
                            >
                                {t('Login with Cognito')}
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}